<div class="flex items-center justify-center z-50">
  <fa-icon [class]="textSize + ' ' + textColor" [icon]="iconAwread"></fa-icon>
</div>
